import { render, staticRenderFns } from "./CoastsAlerts.vue?vue&type=template&id=127b22c9&scoped=true"
import script from "./CoastsAlerts.vue?vue&type=script&lang=js"
export * from "./CoastsAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127b22c9",
  null
  
)

export default component.exports